import type { BdrLeadDetailsProps } from './types'
import { BdrLeadDetailsLeftPanel } from './BdrLeadDetailsLeftPanel'
import { BdrLeadDetailsRightPanel } from './BdrLeadDetailsRightPanel'

export type { BdrLeadDetailsProps } from './types'

export function BdrLeadDetails(props: BdrLeadDetailsProps) {
  return (
    <div className="grid w-full min-h-0 flex-1 grid-cols-1 gap-6 lg:grid-cols-[minmax(0,1fr)_420px] lg:items-start [&>*]:min-w-0">
      <BdrLeadDetailsLeftPanel
        selectedLead={props.selectedLead}
        getCadencia={props.getCadencia}
        closers={props.closers}
        showRegTentativa={props.showRegTentativa}
        setShowRegTentativa={props.setShowRegTentativa}
        regTentativa={props.regTentativa}
        setRegTentativa={props.setRegTentativa}
        savingTentativa={props.savingTentativa}
        handleRegTentativa={props.handleRegTentativa}
      />
      <BdrLeadDetailsRightPanel
        selectedLead={props.selectedLead}
        getCadencia={props.getCadencia}
        handleAddPending={props.handleAddPending}
        togglePending={props.togglePending}
        removePending={props.removePending}
      />
    </div>
  )
}
